import { Button } from '@/shared/components/shadcn/button';
import { XIcon } from 'lucide-react';
import type { SeedPost } from '../../stores/seed-post-store';

interface Props {
  posts: SeedPost[];
  size?: 'composer' | 'message' | 'summary';
  onRemovePost?: (postId: string) => void;
}

export function SeedPostImage({ posts, size = 'message', onRemovePost }: Props) {
  if (posts.length === 0) return null;

  const imageClassName =
    size === 'composer'
      ? 'h-12 w-10 rounded-md border border-border object-cover'
      : size === 'summary'
        ? 'h-12 w-9 rounded-md border border-border object-cover'
        : 'h-16 w-11 rounded-md border border-border object-cover';

  return (
    <div className="flex flex-wrap gap-2">
      {posts.map((post) => {
        const image = <img src={post.posterUrl} alt="" className={imageClassName} />;

        if (!onRemovePost) {
          return <div key={post.id}>{image}</div>;
        }

        return (
          <div key={post.id} className="group/post relative">
            {image}
            <Button
              type="button"
              variant="secondary"
              size="icon"
              className="absolute -top-1.5 -right-1.5 size-6 opacity-0 shadow-sm group-focus-within/post:opacity-100 group-hover/post:opacity-100"
              onClick={() => onRemovePost(post.id)}
              aria-label="Remove selected post"
            >
              <XIcon className="size-3" />
            </Button>
          </div>
        );
      })}
    </div>
  );
}
